var u = Object.defineProperty;
var g = (t, e, i) => e in t ? u(t, e, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[e] = i;
var n = (t, e, i) => (g(t, typeof e != "symbol" ? e + "" : e, i), i);
var b = function() {
  if (!(typeof document > "u")) {
    var t = document.createElement("fakeelement"), e = {
      transition: "transitionend",
      OTransition: "oTransitionEnd",
      MozTransition: "transitionend",
      WebkitTransition: "webkitTransitionEnd"
    };
    for (var i in e)
      if (t.style[i] !== void 0)
        return e[i];
  }
};
const r = b(), f = {
  // Cubic
  easeInCubic: "cubic-bezier(0.550, 0.055, 0.675, 0.190)",
  easeOutCubic: "cubic-bezier(0.215, 0.610, 0.355, 1.000)",
  easeInOutCubic: "cubic-bezier(0.645, 0.045, 0.355, 1.000)",
  // Circ
  easeInCirc: "cubic-bezier(0.600, 0.040, 0.980, 0.335)",
  easeOutCirc: "cubic-bezier(0.075, 0.820, 0.165, 1.000)",
  easeInOutCirc: "cubic-bezier(0.785, 0.135, 0.150, 0.860)",
  // Expo
  easeInExpo: "cubic-bezier(0.950, 0.050, 0.795, 0.035)",
  easeOutExpo: "cubic-bezier(0.190, 1.000, 0.220, 1.000)",
  easeInOutExpo: "cubic-bezier(1.000, 0.000, 0.000, 1.000)",
  // Quad
  easeInQuad: "cubic-bezier(0.550, 0.085, 0.680, 0.530)",
  easeOutQuad: "cubic-bezier(0.250, 0.460, 0.450, 0.940)",
  easeInOutQuad: "cubic-bezier(0.455, 0.030, 0.515, 0.955)",
  // Quart
  easeInQuart: "cubic-bezier(0.895, 0.030, 0.685, 0.220)",
  easeOutQuart: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
  easeInOutQuart: "cubic-bezier(0.770, 0.000, 0.175, 1.000)",
  // Quint
  easeInQuint: "cubic-bezier(0.755, 0.050, 0.855, 0.060)",
  easeOutQuint: "cubic-bezier(0.230, 1.000, 0.320, 1.000)",
  easeInOutQuint: "cubic-bezier(0.860, 0.000, 0.070, 1.000)",
  // Sine
  easeInSine: "cubic-bezier(0.470, 0.000, 0.745, 0.715)",
  easeOutSine: "cubic-bezier(0.390, 0.575, 0.565, 1.000)",
  easeInOutSine: "cubic-bezier(0.445, 0.050, 0.550, 0.950)",
  // Back
  easeInBack: "cubic-bezier(0.600, -0.280, 0.735, 0.045)",
  easeOutBack: "cubic-bezier(0.175,  0.885, 0.320, 1.275)",
  easeInOutBack: "cubic-bezier(0.680, -0.550, 0.265, 1.550)"
};
class p {
  constructor(e) {
    n(this, "getInitialHeight", () => {
      let e = 0;
      for (let i = 0; i <= this.initialOpenedItems - 1; i++) {
        const a = this.el.children[i];
        let h = window.getComputedStyle(a).marginBottom;
        h = +h.replace("px", ""), e = e + a.offsetHeight + h;
      }
      return e;
    });
    n(this, "measureHeight", () => {
      const e = this.el.scrollHeight;
      return this.height !== e ? e : this.height;
    });
    n(this, "setProps", () => {
      this.show ? (this.handler.setAttribute("aria-expanded", "true"), this.openClassName && (this.el.classList.add(this.openClassName), this.handler.classList.add(this.openClassName))) : (this.handler.setAttribute("aria-expanded", "false"), this.openClassName && (this.el.classList.remove(this.openClassName), this.handler.classList.remove(this.openClassName)));
    });
    n(this, "preventLastClose", () => this.handler.getAttribute("aria-expanded") === "true");
    n(this, "setOpenParameters", () => {
      this.el.style.display = "block", this.height = this.measureHeight(), this.el.offsetHeight, this.el.style.height = `${this.height}px`, this.show = !0, this.setProps(), this.toggleStart && this.toggleStart(this.el, "show", this.show);
    });
    n(this, "open", () => {
      this.isAnimating || (this.isAnimating = !0, this._closeInstances.length ? (this._closeInstances.forEach((e) => {
        e && e.show && e.close();
      }), setTimeout(() => this.setOpenParameters(), this.duration)) : this.setOpenParameters());
    });
    n(this, "close", () => {
      this.isAnimating || (this.isAnimating = !0, this.height = this.measureHeight(), this.el.style.height = `${this.height}px`, this.height = 0, this.el.offsetHeight, this.initialOpenedItems ? this.el.style.height = `${this.initialHeight}px` : this.el.style.height = `${this.height}px`, this.show = !1, this.setProps(), this.toggleStart && this.toggleStart(this.el, "hide", this.show));
    });
    n(this, "destroy", () => {
      this.show = this.initOpened || !1, this.handler.classList.remove(this.openClassName), this.handler.setAttribute("aria-expanded", "false"), this.el.removeAttribute("style"), this.el.setAttribute("aria-hidden", "false"), this.el.classList.remove(this.openClassName), this.el.removeEventListener(
        r,
        this.transitionEndAccordion,
        !1
      ), this.handler.removeEventListener("click", this.toggleAccordion);
    });
    n(this, "init", () => {
      if (!this.el || !this.handler) {
        console.error(
          `Pass valid elements to Accordion class. Handler is ${this.handler ? `#${this.handler.id}` : this.handler}, body is ${this.el ? `#${this.el.id}` : this.el}`
        );
        return;
      }
      this.setProps(), !this.initOpened && !this.initialOpenedItems ? (this.el.style.display = "none", this.el.style.height = "0") : this.initialOpenedItems && (this.el.style.height = this.initialHeight + "px"), this.el.style.overflow = "hidden", this.el.style.transition = `height ${this.duration}ms ${this.easing}`, this.el.addEventListener(
        r,
        this.transitionEndAccordion,
        !1
      ), this.handler.addEventListener("click", this.toggleAccordion);
    });
    this.el = e.target, this.handler = e.handler, this.openClassName = e.openClassName || "is-open", this.height = this.measureHeight(), this.initOpened = e.initOpened, this.initialOpenedItems = e.initialOpenedItems || null, this.initialHeight = this.getInitialHeight(), this.show = this.initOpened || !1, this.duration = e.duration || 400, this.easing = f[e.easing] || e.easing || "easeInOutQuart", this.toggleStart = typeof e.toggleStart == "function" ? e.toggleStart : null, this.toggleEnd = typeof e.toggleEnd == "function" ? e.toggleEnd : null, this._closeInstances = [], this.isAnimating = !1, this.preventAllClose = e.preventAllClose || !1, this.toggleAccordion = this.toggle.bind(this), this.transitionEndAccordion = this.onTransitionEnd.bind(this);
  }
  set closeInstances(e) {
    this._closeInstances = e;
  }
  get closeInstances() {
    return this._closeInstances;
  }
  onTransitionEnd() {
    this.show ? (this.el.style.height = "auto", this.el.setAttribute("aria-hidden", "false"), this.toggleEnd && this.toggleEnd(this.el, "show", this.show)) : (this.el.style.display = !this.initialOpenedItems && "none", this.el.setAttribute("aria-hidden", "true"), this.toggleEnd && this.toggleEnd(this.el, "hide", this.show)), this.isAnimating = !1;
  }
  toggle() {
    this.preventAllClose && this.preventLastClose() || (this.show ? this.close() : this.open());
  }
}
function y(t, e = 400, i = "ease-in-out", a = "vertical") {
  return new Promise((h) => {
    const s = a === "vertical" ? "height" : "width";
    t.style.display = "block";
    const l = t.style[s];
    t.style[s] = "auto";
    const o = getComputedStyle(t)[s];
    t.style[s] = l, t.offsetHeight, t.style.transition = `${s} ${e}ms ${i}`, t.style[s] = o, t.addEventListener(
      r,
      function c(d) {
        d.propertyName === s && (t.removeEventListener(r, c, !1), t.style.transition = "", t.style[s] = "auto", h());
      },
      !1
    );
  });
}
function v(t, e = 400, i = "ease-in-out", a = "vertical") {
  return new Promise((h) => {
    const s = a === "vertical" ? "height" : "width";
    t.style[s] = getComputedStyle(t)[s], t.style.transition = `${s} ${e}ms ${i}`, t.offsetHeight, t.style[s] = "0px", t.addEventListener(
      r,
      function l(o) {
        o.propertyName === s && (t.removeEventListener(r, l, !1), t.style.transition = "", t.style.display = "none", h());
      },
      !1
    );
  });
}
export {
  p as Accordion,
  v as slideClose,
  y as slideOpen
};
